// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.alert-container[data-v-3fb06f93] {\n  display: grid;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  text-align: center;\n  margin: 10px 25px;\n}\n.alert-icon[data-v-3fb06f93] {\n  background-color: #FFF3E0;\n  border: 1px solid transparent;\n  border-radius: 50%;\n  padding: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
